import { useLayoutStore } from '../../layout';
import { Search, Favorite, Burger, Cart, Member } from './actions';

export function StatusBar() {
  const isDesktop = useLayoutStore.use.isDesktop();

  return (
    <div className="tlw-flex tlw-items-center tlw-gap-5 tlw-shrink-0">
      <div className="tlw-flex tlw-gap-5">
        <Search />

        {isDesktop && <Favorite />}
      </div>

      <div className="tlw-flex tlw-items-center tlw-gap-2">
        <Cart />

        {isDesktop ? <Member hasDropdown /> : <Burger />}
      </div>
    </div>
  );
}
